import { style, animate, transition } from "@angular/animations";

export function fadeIn(milli = 400) {
  return [
    transition(":enter", [
      style({ opacity: 0 }),
      animate(`${milli}ms ease-in`, style({ opacity: 1 })),
    ]),
  ];
}
